//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx";
import Swal from "sweetalert2";

export default {
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);
    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // await this.loaddataappointmentLimit200();
    await this.loaddatadocumenttype();
    this.$hideLoader();
    // await this.loaddataappointment();
    // this.$showLoader();
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data(vm) {
    const today = new Date();
    const todayStr = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1
    ).padStart(2, "0")}/${today.getFullYear()}`;

    const plus30 = new Date();
    plus30.setDate(today.getDate() + 30);
    const plus30Str = `${String(plus30.getDate()).padStart(2, "0")}/${String(
      plus30.getMonth() + 1
    ).padStart(2, "0")}/${plus30.getFullYear()}`;

    // แปลง DD/MM/YYYY เป็น YYYY-MM-DD สำหรับ DatePicker
    const toYMD = (ddmmyyyy) => {
      const [dd, mm, yyyy] = ddmmyyyy.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };
    return {
      dialogSelectInvType: "invoice",
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      table_id_export_list: "",
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      exportleavequota: "Docket_Trademark.xlsx",
      sheetName: "Docket_Trademark",
      sheets: [
        {
          name: "Docket_Trademark",
          data: [],
        },
      ],
      itemsPerPageArray: [10, 15, 20],
      // page: 1,
      pageSize: 3,
      pageSizes: [3, 6, 9],
      // pageCount: 0,
      // itemsPerPage: 100,
      deletedItem: 0,
      dialogDelete: false,
      searchdatefrom: todayStr,
      searchdateto: plus30Str,
      searchdatefromS: null,
      searchdatetoPicker: toYMD(plus30Str),
      searchdatefromF: "",
      searchdatetoF: "",
      searchdocumenttype: "",
      searchtrademark_name: "",
      searchfile_no: "",
      searchapp_no: "",
      menuadddatefrom: false,
      menuadddateto: false,
      documenttype_list: [],
      isShowPassword: false,
      fullPage: true,
      search: "",
      dateCurrent: vm.formatDateday(new Date().toISOString().substr(0, 10)),
      headers: [
        {
          text: "File No.",
          align: "left",
          value: "refno",
          divider: true,
          width: "100px",
        },
        {
          text: "Application No.",
          value: "app_no",
          divider: true,
          width: "140px",
        },
        {
          text: "Client Name",
          value: "owner_name",
          divider: true,
          width: "200px",
        },
        {
          text: "Agent Reference",
          value: "cliant_ref",
          divider: true,
          width: "100px",
        },
        {
          text: "Agent",
          value: "agent_contact_name",
          divider: true,
          width: "230px",
        },
        {
          text: "Billing Customer",
          value: "cus_name",
          divider: true,
          width: "230px",
        },
        {
          text: "Invoice No.",
          value: "inv_list",
          divider: true,
          width: "230px",
        },
        {
          text: "Invoice Status",
          value: "inv_status_list",
          divider: true,
          width: "230px",
        },

        {
          text: "Work Type",
          align: "left",
          // sortable: true,
          value: "documenttype_code",
          width: "250px",
          divider: true,
        },
        // { text: "Notice Type", value: "notice_name", divider: true },
        {
          text: "Doc Type",
          sortable: false,
          value: "documenttype_actions",
          divider: true,
          width: "300px",
        },
        { text: "Note", value: "user_note", divider: true, width: "100px" },
        {
          text: "Reported / Invioced",
          value: "reportnow",
          divider: true,
          width: "170px",
        },
        {
          text: "Last Updated / Create by",
          value: "last_update",
          divider: true,
          width: "250px",
        },
        { text: "Status", value: "statusnow", divider: true, width: "150px" },
        {
          text: "Deadline Date",
          value: "enddate",
          divider: true,
          width: "150px",
        },
        // { text: "Filed Date", value: "filed_date", divider: true },

        {
          text: "",
          value: "actions",
          width: "100px",
          align: "center",
          divider: true,
        },
      ],
      mDataArray: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      load_bg: false,
      statusSearch: 0,
      statuslist: [
        { status_name: "Pending", status_value: 1 },
        { status_name: "Completed", status_value: 2 },
        { status_name: "Close", status_value: 3 },
        { status_name: "Payment Request", status_value: 4 },
      ],
      excelData: [], // ยังไม่มีข้อมูลตอนเริ่มต้น
      excelFileName: "Docket_Trademark.xlsx",
      oldSearch: {
        searchdocumenttype: "",
        searchtrademark_name: "",
        searchfile_no: "",
        searchapp_no: "",
        searchdatefrom: null,
        searchdateto: null,
        statusSearch: "",
      },
      selectedItems: [],
      dialogOpenPayment: false,
    };
  },
  methods: {
    onDialogPayMent() {
      this.dialogOpenPayment = true;
    },
    onSavePayMent() {
      var warningAlert = false;
      var firstBillingId = null;
      var agentRef = "";
      var fileNoRef = "";
      var cusBilling = "";
      var docketID = "";

      for (const [index, item] of this.selectedItems.entries()) {
        // เช็คค่าว่างก่อน
        if (item.cus_billing_id == null) {
          warningAlert = true;
          break;
        }

        // เก็บตัวแรกไว้เป็นค่าอ้างอิง
        if (index === 0) {
          firstBillingId = item.cus_billing_id;
        }

        // เทียบค่าถัดไปว่าต้องเหมือนกันทุกตัว
        if (item.cus_billing_id !== firstBillingId) {
          warningAlert = true;
          break;
        }
      }
      if (warningAlert) {
        this.dialogOpenPayment = false;
        this.selectedItems = [];
        Swal.fire({
          icon: "warning",
          title: "Warnning Data",
          text: " Billing ID not found. Please verify the information and try again.",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
        return;
      } else {
        if (
          Array.isArray(this.selectedItems) &&
          this.selectedItems.length > 0
        ) {
          cusBilling = this.selectedItems[0].cus_name;
          // agentRef = this.selectedItems[0].cliant_ref ;
          agentRef = this.selectedItems
            .map((item) => item.cliant_ref)
            .filter((ref) => ref != null && ref !== "")
            .join(", ");
          fileNoRef = this.selectedItems
            .map((item) => item.refno)
            .filter((ref) => ref != null && ref !== "")
            .join(", ");
          docketID = this.selectedItems
            .map((item) => item.appointment_id)
            .filter((ref) => ref != null && ref !== "")
            .join(",");
        }

        var dataPush = {
          customer_name_master: cusBilling,
          yourRef: "",
          ourRef: "",
          docketId: docketID,
        };

        var custonerId = 0;
        custonerId = this.selectedItems[0].cus_billing_id;

        const hasThai = /[\u0E00-\u0E7F]/;
        if (hasThai.test(cusBilling)) {
          dataPush.yourRef = `เลขที่อ้างอิงของลูกค้า: ${agentRef}`;
          dataPush.ourRef = `เลขที่อ้างอิงของบริษัท: ${fileNoRef}`;
        } else {
          dataPush.yourRef = `Your Ref: ${agentRef}`;
          dataPush.ourRef = `Our Ref: ${fileNoRef}`;
        }
        if (agentRef.trim() == "") {
          dataPush.yourRef = "";
        }
        this.dialogOpenPayment = false;
        if (this.dialogSelectInvType == "invoice") {
          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${custonerId}/Docket`,
            query: dataPush,
          });
        } else if (this.dialogSelectInvType == "performa") {
          this.$router.push({
            path: `/new-free-invoice/0/performa/D/${custonerId}/Docket`,
            query: dataPush,
          });
        }
      }
    },
    async exportExcel() {
      var number = this.itemsPerPage * this.pageCount;
      if (number > 10000) {
        Swal.fire({
          icon: "warning",
          title: "export ไม่สำเร็จ",
          text: "ข้อมูลมากเกินไป",
          showConfirmButton: false, // ❌ ไม่แสดงปุ่ม OK
          timer: 2000, // ⏱ แสดง 2 วินาทีแล้วปิดเอง
          timerProgressBar: true, // แถบเวลานับถอยหลัง (optional)
        });
      } else {
        this.$showLoader();
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },

    async setexporttoxlsx() {
      var resdata = await api.loadDataExportTm(
        this.oldSearch.searchdocumenttype,
        this.oldSearch.searchtrademark_name,
        this.oldSearch.searchfile_no,
        this.oldSearch.searchapp_no,
        this.oldSearch.searchdatefrom,
        this.oldSearch.searchdateto,
        this.oldSearch.statusSearch
      );
      if (resdata.status == 201) {
        const dataAll = resdata.data;
        var dataList = [];
        dataAll.forEach((item, index) => {
          dataList.push({
            WorkType: item.documenttype_code,
            FileNo: item.refno,
            ApplicationNo: item.app_no,
            TrademarkName: item.trademark_name,
            Owner: item.owner_name,
            Agent: item.agent_contact_name,
            FinalDate:
              item.FinalDate && item.FinalDate !== "0000-00-00"
                ? item.FinalDate
                : "",
            Status: item.statusnow,
          });
        });
        const prefix = [{}, {}];
        this.excelData = [...prefix, ...dataList];
      }
    },

    onChange(wb) {
      const ws = wb.Sheets.Docket_Trademark;
      if (!ws) return;

      // ✅ รวมเซลล์ A1 ถึง H1
      ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];

      // ✅ ตั้งหัวเรื่องใหญ่
      ws["A1"] = {
        t: "s",
        v: `Export Trademark Docket as of ${this.dateCurrent}`,
      };

      // ✅ ตั้งชื่อคอลัมน์
      ws["A3"] = { t: "s", v: "Work Type" };
      ws["B3"] = { t: "s", v: "File No" };
      ws["C3"] = { t: "s", v: "Application No" };
      ws["D3"] = { t: "s", v: "Trademark Name" };
      ws["E3"] = { t: "s", v: "Owner" };
      ws["F3"] = { t: "s", v: "Agent" };
      ws["G3"] = { t: "s", v: "Final Deadline" };
      ws["H3"] = { t: "s", v: "Status" };
    },

    onActionChange(item, action, val) {
      this.$showLoader();
      console.log(action.id);
      var dataUpdate = {
        documenttype_follow: 0,
        documenttype_action_id: action.documenttype_action_id,
        appointment_id: item.appointment_id,
        appointment_type: `Trademark`,
      };
      if (val) {
        dataUpdate.documenttype_follow = 1;
      } else {
        dataUpdate.documenttype_follow = 0;
      }

      setTimeout(() => {
        api.updateAppointmentDoctypeActions(dataUpdate).finally(() => {
          this.$hideLoader();
        });
      }, 500);
    },
    startEditingNote(item) {
      this.$set(item, "editing_note", true); // สำหรับ Vue 2 (Vuetify 2)
      // item.editing_note = true // ถ้าเป็น Vue 3 ใช้อันนี้ได้เลย

      this.$nextTick(() => {
        // หา text field ที่เปิดใหม่แล้ว focus
        const field = this.$refs.noteField;
        if (Array.isArray(field)) {
          // ใน v-data-table อาจมีหลายช่อง → เลือกช่องของ row ปัจจุบัน
          const currentField = field.find(
            (f) => f.$el && f.$el.offsetParent !== null
          );
          if (currentField) currentField.focus();
        } else if (field && field.focus) {
          field.focus();
        }
      });
    },

    finishEditingNote(item) {
      // ปิด edit mode
      item.editing_note = false;

      // เรียก API update note
      this.updateNote(item);
    },

    async updateNote(item) {
      this.$showLoader();
      setTimeout(async () => {
        try {
          if (item.user_note) {
            var dataUpdateNote = {
              user_note: item.user_note,
            };
            await api.updateAppointmentData(
              Number(item.appointment_id),
              dataUpdateNote
            );
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.$hideLoader();
        }
      }, 500);
    },
    formatDateToDDMMYYYY(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      try {
        const result = await api.getAllAppointmentPagination(
          1,
          this.itemsPerPage,
          "appointment_id",
          "ASC",
          this.searchdocumenttype,
          this.searchtrademark_name,
          this.searchfile_no,
          this.searchapp_no,
          this.searchdatefrom,
          this.searchdateto
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "ASC";
      } else {
        sortDesc = "DESC";
      }
      if (!this.options.sortBy[0]) {
        sortDesc = "ASC";
      }

      var sSearh;
      if (this.statusSearch == 0) {
        sSearh = null;
      } else {
        sSearh = this.statusSearch;
      }

      this.oldSearch.searchdocumenttype = this.searchdocumenttype;
      this.oldSearch.searchtrademark_name = this.searchtrademark_name;
      this.oldSearch.searchfile_no = this.searchfile_no;
      this.oldSearch.searchapp_no = this.searchapp_no;
      this.oldSearch.searchdatefrom = this.searchdatefrom;
      this.oldSearch.searchdateto = this.searchdateto;
      this.oldSearch.statusSearch = sSearh;
      try {
        const result = await api.getAllAppointmentPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          this.searchdocumenttype,
          this.searchtrademark_name,
          this.searchfile_no,
          this.searchapp_no,
          this.searchdatefrom,
          this.searchdateto,
          sSearh
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
        this.mDataArray2 = this.mDataArray2.map((item) => ({
          ...item,
          documenttype_actions: JSON.parse(item.documenttype_actions || "[]"),
        }));
        // await this.setexporttoxlsx();
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.options.sortBy = [];
      this.options.sortDesc = [];
      let sortDesc = "";

      var sSearh;
      if (this.statusSearch == 0) {
        sSearh = null;
      } else {
        sSearh = this.statusSearch;
      }
      try {
        const result = await api.getAllAppointmentPagination(
          pageNumber,
          this.itemsPerPage,
          "enddate",
          "ASC",
          this.searchdocumenttype,
          this.searchtrademark_name,
          this.searchfile_no,
          this.searchapp_no,
          this.searchdatefrom,
          this.searchdateto,
          sSearh
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
        this.mDataArray2 = this.mDataArray2.map((item) => ({
          ...item,
          documenttype_actions: JSON.parse(item.documenttype_actions || "[]"),
        }));
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;
      this.options.sortBy = [];
      this.options.sortDesc = [];

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "enddate",
        sortDesc: "ASC",
        searchdocumenttype: this.searchdocumenttype,
        searchtrademark_name: this.searchtrademark_name,
        searchfile_no: this.searchfile_no,
        searchapp_no: this.searchapp_no,
        searchdatefrom: this.searchdatefrom,
        searchdateto: this.searchdateto,
      };
      var sSearh;
      if (this.statusSearch == 0) {
        sSearh = null;
      } else {
        sSearh = this.statusSearch;
      }
      this.oldSearch.searchdocumenttype = this.searchdocumenttype;
      this.oldSearch.searchtrademark_name = this.searchtrademark_name;
      this.oldSearch.searchfile_no = this.searchfile_no;
      this.oldSearch.searchapp_no = this.searchapp_no;
      this.oldSearch.searchdatefrom = this.searchdatefrom;
      this.oldSearch.searchdateto = this.searchdateto;
      this.oldSearch.statusSearch = sSearh;

      try {
        const result = await api.getAllAppointmentPagination(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortDesc,
          s_data.searchdocumenttype,
          s_data.searchtrademark_name,
          s_data.searchfile_no,
          s_data.searchapp_no,
          s_data.searchdatefrom,
          s_data.searchdateto,
          sSearh
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
        this.mDataArray2 = this.mDataArray2.map((item) => ({
          ...item,
          documenttype_actions: JSON.parse(item.documenttype_actions || "[]"),
        }));
        // await this.setexporttoxlsx();
      }
    },

    async export_log() {
      if (this.table_id_export_list != "") {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Export",
          table_name: "appointment",
          table_id: this.table_id_export_list,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );
      }
    },
    onCreated(wb) { },

    async loaddataappointmentLimit200() {
      // this.$showLoader();

      const result = await api.getAllAppointment200();
      console.log(result.data);
      // const result = await api.getAllMasterTM();
      this.mDataArray = result.data;
      await this.setexporttoxlsx();

      // this.$hideLoader();
    },
    async loaddataappointment() {
      const result = await api.getAllAppointment();
      console.log(result.data);
      this.mDataArray = result.data;
      let setexportxlsx = [];
      await this.setexporttoxlsx();
    },
    async onSearchAll() {
      if (this.searchdocumenttype) {
        this.onSelectdocumenttype();
      } else if (this.searchtrademark_name) {
        this.onSearchtrademark_name();
      } else if (this.searchfile_no) {
        this.onSearchfile_no();
      } else if (this.searchapp_no) {
        this.onSearchapp_no();
      }
    },
    async onSelectdocumenttype(data) {
      this.$showLoader();
      this.searchtrademark_name = "";
      this.searchfile_no = "";
      this.searchapp_no = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      console.log(this.searchdocumenttype);
      const result = await api.searchdataAppointment({
        params: {
          searchdocumenttype: this.searchdocumenttype,
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchtrademark_name() {
      this.$showLoader();
      this.searchfile_no = "";
      this.searchapp_no = "";
      this.searchdocumenttype = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      const result = await api.searchdataAppointment({
        params: {
          searchtrademark_name: this.searchtrademark_name.trim(),
          searchdatefrom: this.searchdatefrom,
          searchdateto: this.searchdateto,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchfile_no() {
      this.$showLoader();
      this.searchapp_no = "";
      this.searchtrademark_name = "";
      this.searchdocumenttype = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      const result = await api.searchdataAppointment({
        params: {
          searchfile_no: this.searchfile_no.trim(),
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchapp_no() {
      this.$showLoader();
      this.searchfile_no = "";
      this.searchtrademark_name = "";
      this.searchdocumenttype = "";
      // this.searchdatefrom = "";
      // this.searchdateto = "";
      const result = await api.searchdataAppointment({
        params: {
          searchapp_no: this.searchapp_no.trim(),
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchdatefrom() {
      this.$showLoader();
      // this.searchfile_no = "";
      // this.searchtrademark_name = "";
      // this.searchdocumenttype = "";
      // this.searchapp_no = "";
      if (!this.searchdatetoF) {
        this.$hideLoader();
        return;
      }
      const result = await api.searchdataAppointment({
        params: {
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
          searchfile_no: this.searchfile_no,
          searchtrademark_name: this.searchtrademark_name,
          searchdocumenttype: this.searchdocumenttype,
          searchapp_no: this.searchapp_no,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async onSearchdateto() {
      this.$showLoader();
      // this.searchfile_no = "";
      // this.searchtrademark_name = "";
      // this.searchdocumenttype = "";
      // this.searchapp_no = "";
      if (!this.searchdatefromF) {
        this.$hideLoader();
        return;
      }
      const result = await api.searchdataAppointment({
        params: {
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
          searchfile_no: this.searchfile_no,
          searchtrademark_name: this.searchtrademark_name,
          searchdocumenttype: this.searchdocumenttype,
          searchapp_no: this.searchapp_no,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async SearchAll() {
      this.$showLoader();
      const result = await api.searchdataAppointment({
        params: {
          searchdatefrom: this.searchdatefromF,
          searchdateto: this.searchdatetoF,
          searchfile_no: this.searchfile_no,
          searchtrademark_name: this.searchtrademark_name,
          searchdocumenttype: this.searchdocumenttype,
          searchapp_no: this.searchapp_no,
        },
      });
      if (result.status == 204) {
        await this.loaddataappointmentLimit200();
        this.$hideLoader();
        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Search data ",
        //   "Please input Search data",
        //   "text-h5 red--text text-center"
        // );
        // return;
      } else {
        this.mDataArray = result.data;
        let setexportxlsx = [];
        await this.setexporttoxlsx();
        this.$hideLoader();
      }
    },
    async loaddatadocumenttype() {
      const result = await api.getdocumenttype_code();
      // console.log(result.data);
      this.documenttype_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async openAppointmentadd() {
      let file_no = " ";
      let date_of_renewal = "null";
      localStorage.setItem(server.MODELMENU, 6);
      this.$router.push(`/appointmenttm-add/${file_no}/${date_of_renewal}`);
    },
    async openeditItem(appointment_id) {
      // this.$router.push(`/appointmenttm-edit/${appointment_id}`);
      window.open(`/appointmenttm-edit/${appointment_id}`);
    },
    deleteItem(item) {
      this.deletedIndex = this.mDataArray.indexOf(item);
      console.log(item.appointment_id);
      this.deletedItem = item.appointment_id;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.deletedItem = 0;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.$showLoader();
      this.mDataArray.splice(this.deletedIndex, 1);
      this.dialogDelete = false;
      // let setflag = 0;
      // // 0 = delete
      // const resdel = await api.AppointmentUpdate(this.deletedItem, {
      //   ocr_flag: setflag,
      // });
      const resdel = await api.AppointmentDeleteMode(this.deletedItem);
      console.log(resdel);
      if (resdel.status == 200) {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Delete",
          table_name: "appointment",
          table_id: this.deletedItem,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialog(
          true,
          "delete data",
          "delete data success",
          "text-h5 green--text text-center"
        );
        return;
      } else {
        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "delete data",
          "can't delete data",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    formatDateToDMY(dateStr) {
      // ตรวจสอบว่าเป็นรูปแบบ yyyy-mm-dd
      const [yyyy, mm, dd] = dateStr.split("-");
      if (!yyyy || !mm || !dd) return "";
      return `${dd}/${mm}/${yyyy}`;
    },

    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  watch: {
    searchdatefromF(val) {
      this.searchdatefrom = this.formatDate(this.searchdatefromF);
    },
    searchdatetoF(val) {
      this.searchdateto = this.formatDate(this.searchdatetoF);
    },
    excelData(newVal) {
      if (newVal.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.xlsxDownload) {
            this.$refs.xlsxDownload.download();
          }
        });
      }
    },
  },
};
